module.exports = __webpack_public_path__ + "img/image2.2d7210da.png";